var React = require('react');

function Mercury (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.114 2l-1.911.183a6.929 6.929 0 003.288 5.25c-2.646 1.314-4.476 4.04-4.476 7.186 0 4.095 3.096 7.485 7.066 7.962v2.598h-2.24v1.92h2.24v2.24h1.92v-2.24h2.24v-1.92h-2.24V22.58c3.97-.477 7.065-3.867 7.065-7.962 0-3.122-1.8-5.83-4.413-7.156a6.927 6.927 0 003.34-5.273l-1.912-.185a4.996 4.996 0 01-4.986 4.528A4.996 4.996 0 0111.114 2zm4.927 6.512a6.091 6.091 0 016.105 6.107 6.09 6.09 0 01-6.105 6.105 6.091 6.091 0 01-6.106-6.105 6.092 6.092 0 016.106-6.107z"}));
}

Mercury.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Mercury;

Mercury.default = Mercury;
